import React from "react";
import { sendAnalyticsEvent } from "../../../../../utils/helper";

const DeliveryBottomSheet = ({
  isShowDelivery = false,
  pathnerList = [],
  selectedPathner = null,
  setSelectedPathner = () => {},
  setValues = () => {},
  setIsShowDelivery = () => {},
  setIsShowBottomSheet = () => {}
}) => {
  if (!isShowDelivery) return null;

  return (
    <div
      className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out rounded-t-xl ${isShowDelivery ? "translate-y-0 relative" : "translate-y-full hidden"}`}
    >
      <div className="flex justify-center py-4 text-base text-gray-900 font-semibold">
        Layanan Antar
      </div>
      {pathnerList?.map((pathner, index) => {
        return (
          <div
            key={`pathner_${index}`}
            className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center`}
            onClick={() => {
              setSelectedPathner(pathner);
              sendAnalyticsEvent(
                "Select Delivery",
                "summary_select_delivery",
                pathner?.name
              );
              if (pathner?.vehicle?.length === 1) {
                setValues((prev) => {
                  return {
                    ...prev,
                    deliveryType: pathner?.vehicle?.[0] || null
                  };
                });
              }
            }}
          >
            <div className="">
              <div
                className={`text-sm capitalize text-gray-900 font-semibold`}
              >{`${pathner?.name} ${pathner?.serviceType}`}</div>
              <div className="text-xs text-gray-400 pt-1 font-thin">
                Perkiraan tiba 30-40 menit langsung ke Anda
              </div>
            </div>
            <div className="flex">
              <div className="pl-2">
                <input
                  id="pathner"
                  type="radio"
                  name="pathner"
                  value={pathner?.name}
                  checked={selectedPathner?.name === pathner?.name}
                  onChange={() => null}
                  className={`${
                    selectedPathner?.name === pathner?.name
                      ? "!border-[var(--rose-violet)]"
                      : "!border-gray-400"
                  } after:!bg-[var(--rose-violet)] active:bg-white !focus:ring-0 !focus:bg-transparent focus:shadow-none`}
                />
              </div>
            </div>
          </div>
        );
      })}
      <button
        id="summary_confirm_delivery"
        className="mt-10 w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm p-3 border-0 items-center"
        onClick={() => {
          setIsShowDelivery(false);
          setIsShowBottomSheet(false);
        }}
      >
        Pilih
      </button>
    </div>
  );
};

export default DeliveryBottomSheet;
